{
  "metadata": {
    "id": "blood-moon-light",
    "name": "Blood Moon",
    "description": "Собственная тема Synth «Blood Moon» (light)",
    "author": "Synth",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "synth",
      "own"
    ],
    "source": {
      "file": "tools/lib/make_themes.py",
      "project": "synth",
      "url": null,
      "upstreamFile": null,
      "license": "собственная (Synth)",
      "authoring": "tools/lib/make_themes.py"
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 26.1,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.436,
      "paletteMaxS": 0.52,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.2,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 25.4,
      "syntaxVsTextMinDeltaE": 27.0,
      "chartsMinDeltaE": 32.5,
      "textSeparationDeltaE": 21.4,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "comment",
          "b": "operator",
          "deltaE": 4.9
        },
        {
          "a": "keyword",
          "b": "number",
          "deltaE": 15.7
        },
        {
          "a": "keyword",
          "b": "function",
          "deltaE": 5.8
        },
        {
          "a": "string",
          "b": "type",
          "deltaE": 6.8
        },
        {
          "a": "number",
          "b": "function",
          "deltaE": 17.2
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#8E2F2F",
      "hover": "#802a2a",
      "active": "#742727",
      "foreground": "#ffffff",
      "muted": "#8e2f2f80",
      "emphasis": "#8E2F2F"
    },
    "surface": {
      "background": "#FBF5F3",
      "foreground": "#201413",
      "muted": "#cec6c4",
      "mutedForeground": "#4d4240",
      "elevated": "#b8afad",
      "elevatedForeground": "#201413",
      "raised": "#9e9492",
      "raisedForeground": "#201413",
      "overlay": "#fbf5f333",
      "subtle": "#e4dddb"
    },
    "interactive": {
      "border": "#978d8c",
      "borderHover": "#beb6b4",
      "borderFocus": "#8E2F2F",
      "selection": "#20141324",
      "selectionForeground": "#201413",
      "focus": "#8e2f2f59",
      "focusRing": "#8e2f2f47",
      "cursor": "#140e0e",
      "hover": "#20141317",
      "active": "#20141324"
    },
    "status": {
      "error": "#A3261F",
      "errorForeground": "#ffffff",
      "errorBackground": "#a3261f1a",
      "errorBorder": "#a3261f59",
      "warning": "#956813",
      "warningForeground": "#ffffff",
      "warningBackground": "#9568131a",
      "warningBorder": "#95681359",
      "success": "#4F7A46",
      "successForeground": "#ffffff",
      "successBackground": "#4f7a461a",
      "successBorder": "#4f7a4659",
      "info": "#5C5470",
      "infoForeground": "#ffffff",
      "infoBackground": "#5c54701a",
      "infoBorder": "#5c547059"
    },
    "pr": {
      "open": "#4F7A46",
      "draft": "#5d504d",
      "blocked": "#956813",
      "merged": "#A33A3A",
      "closed": "#A3261F"
    },
    "syntax": {
      "base": {
        "background": "#cec6c4",
        "foreground": "#201413",
        "comment": "#5b4f4c",
        "keyword": "#962e2e",
        "string": "#6a4d0c",
        "number": "#873d23",
        "function": "#8E2F2F",
        "variable": "#33201E",
        "type": "#684d0e",
        "operator": "#5d504d"
      },
      "tokens": {
        "commentDoc": "#5b4f4c",
        "stringEscape": "#5d504d",
        "keywordImport": "#962e2e",
        "storageModifier": "#962e2e",
        "functionCall": "#8E2F2F",
        "method": "#8E2F2F",
        "variableProperty": "#8E2F2F",
        "variableOther": "#33201E",
        "variableGlobal": "#873d23",
        "variableLocal": "#5d504d",
        "parameter": "#33201E",
        "constant": "#873d23",
        "class": "#684d0e",
        "className": "#684d0e",
        "interface": "#684d0e",
        "struct": "#684d0e",
        "enum": "#684d0e",
        "typeParameter": "#684d0e",
        "namespace": "#684d0e",
        "module": "#962e2e",
        "tag": "#962e2e",
        "jsxTag": "#962e2e",
        "tagAttribute": "#8E2F2F",
        "tagAttributeValue": "#6a4d0c",
        "boolean": "#873d23",
        "decorator": "#962e2e",
        "label": "#8E2F2F",
        "regexp": "#6a4d0c"
      }
    },
    "charts": {
      "series": [
        "#8E2F2F",
        "#5C5470",
        "#4F7A46",
        "#956813",
        "#bd4c05"
      ]
    },
    "chat": {
      "background": "#FBF5F3",
      "userMessage": "#201413",
      "userMessageBackground": "#b8afad",
      "assistantMessage": "#201413",
      "assistantMessageBackground": "#cec6c4",
      "timestamp": "#5d504d",
      "divider": "#978d8c",
      "typing": "#5d504d"
    },
    "loading": {
      "spinner": "#8E2F2F",
      "spinnerTrack": "#cec6c4",
      "skeleton": "#cec6c4",
      "shimmer": "#c4bbb9"
    },
    "tools": {
      "background": "#cec6c4",
      "border": "#978d8c",
      "headerHover": "#c5bdbb",
      "icon": "#8E2F2F",
      "title": "#201413",
      "description": "#5d504d",
      "edit": {
        "added": "#4F7A46",
        "addedBackground": "#4f7a461a",
        "removed": "#A3261F",
        "removedBackground": "#a3261f1a",
        "modified": "#5C5470",
        "modifiedBackground": "#5c54701a",
        "lineNumber": "#5d504d"
      }
    },
    "markdown": {
      "heading1": "#201413",
      "heading2": "#201413",
      "heading3": "#201413",
      "heading4": "#201413",
      "link": "#8E2F2F",
      "linkHover": "#802a2a",
      "inlineCode": "#6a4d0c",
      "inlineCodeBackground": "#cec6c4",
      "blockquote": "#5d504d",
      "blockquoteBorder": "#978d8c",
      "listMarker": "#8e2f2fbf",
      "bold": "#201413",
      "italic": "#201413e6",
      "strikethrough": "#5d504d",
      "hr": "#978d8c"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c56054",
        "foreground": "#000000",
        "contrast": 5.18
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#855e40",
        "foreground": "#ffffff",
        "contrast": 5.72
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c99c5b",
        "foreground": "#000000",
        "contrast": 8.39
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#ccce64",
        "foreground": "#000000",
        "contrast": 12.58
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#84cc60",
        "foreground": "#000000",
        "contrast": 10.79
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#4e8844",
        "foreground": "#000000",
        "contrast": 4.93
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#62cb90",
        "foreground": "#000000",
        "contrast": 10.46
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438f7c",
        "foreground": "#000000",
        "contrast": 5.46
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#5eb3c9",
        "foreground": "#000000",
        "contrast": 8.77
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#416f85",
        "foreground": "#ffffff",
        "contrast": 5.47
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5978bb",
        "foreground": "#000000",
        "contrast": 4.83
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#5451bf",
        "foreground": "#ffffff",
        "contrast": 6.35
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#663e82",
        "foreground": "#ffffff",
        "contrast": 8.15
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c659c1",
        "foreground": "#000000",
        "contrast": 5.6
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#a83d7a",
        "foreground": "#ffffff",
        "contrast": 5.81
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#833e4c",
        "foreground": "#ffffff",
        "contrast": 7.61
      }
    ]
  }
}
